<template>
  <div>
     <!-- 司机信息 -->
    <el-drawer
      title="选择司机"
      :visible.sync="tableVisible"
      direction="rtl"
      size="50%"
      :modal="false"
      @close="close"
      @opened="addGoodOpen"
    >
      <div ref="searchBox" style="margin:26px 0">
        <el-form
          :inline="true"
          :model="derverFrom"
          ref="derverFrom"
          class="demo-form-inline"
          label-width="86px"
          size="mini"
        >
          <div class="searchBox inpBox">
            <div>
              <el-form-item label="司机姓名:" prop="name">
                <el-input placeholder type="text" v-model="derverFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input placeholder v-model="derverFrom.mobile"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="searchBtnBox" style="padding-left:20px;">
            <el-form-item>
              <el-button type="primary" @click="SJsearchFn">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="resetForm('derverFrom')">重置</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addDerver()">新增司机信息</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div :style="{height:sjh}">
        <el-table
          :data="gridData"
          ref="xzdz"
          height="100%"
          highlight-current-row
          @current-change="selderverChange"
        >
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="name" width="120" :show-overflow-tooltip="true" label="司机姓名"></el-table-column>

          <el-table-column prop="mobile" width="150" label="联系电话"></el-table-column>
          <el-table-column
            prop="identityNo"
            width="200"
            :show-overflow-tooltip="true"
            label="身份证号"
          ></el-table-column>
          <el-table-column
            prop="bankCard"
            width="160"
            :show-overflow-tooltip="true"
            label="银行卡号"
          ></el-table-column>
          <el-table-column
            prop="bankName"
            width="160"
            :show-overflow-tooltip="true"
            label="开户行"
          ></el-table-column>
          <el-table-column prop="bankCardUser" label="收款人"></el-table-column>
        </el-table>
      </div>
      <!-- 分页------ -->
      <div>
        <el-pagination
          background
          @size-change="derverChange"
          @current-change="derverCurrentChange"
          :current-page="derverFrom.pageNo"
          :page-sizes="[25,50,100,200,1000]"
          :page-size="derverFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="siJiTotal"
        ></el-pagination>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import { cDlist } from '@/api/vgs-driver'
import DonMessage from '@/utils/message'
export default {
  name: 'SelectSiji',
  data () {
    return {
      // table: false,
      derverFrom: {
        pageNo: 1,
        pageSize: 50,
        name: '', // 司机姓名
        mobile: '' // 司机电话
      },

      sjh: '500px',
      gridData: [],
      siJiTotal: 0,
      tableVisible: false
    }
  },
  props: {
    table: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    table: {
      deep: true,
      immediate: true,
      handler (val) {
        console.log(val)
        this.tableVisible = val
      }
    }
  },
  mounted () {
    this.cDlistS()
  },
  methods: {
    // 打开司机信息弹窗
    addGoodOpen () {
      let pH = document.documentElement.clientHeight
      this.sjh = pH - 90 - 126 + 'px'
    },
    // 司机信息接口
    cDlistS () {
      cDlist(this.derverFrom)
        .then((res) => {
          this.siJiTotal = res.total
          this.gridData = []
          this.gridData = res.list
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 司机查询
    SJsearchFn () {
      this.cDlistS()
    },
    // 司机重置
    resetForm (formName) {
      this.derverFrom = {
        pageNo: 1,
        pageSize: 50,
        name: '', // 司机姓名
        mobile: '' // 司机电话
      }
      this.cDlistS()
    },
    // 新增司机信息
    addDerver () {
      this.$router.push({ name: 'driver' })
    },
    // 点击司机表格当前行
    selderverChange (row) {
      this.$emit('selectDriver', row)
      // if (row) {
      //   this.$set(this.$parent.xzFormData, 'driverName', row.name) // 司机姓名
      //   this.$set(this.addFormData, 'driverPhone', row.mobile) // 司机电话
      //   this.$set(this.addFormData, 'driverID', row.identityNo) // 身份证
      //   if (this.sijiChange == true) {
      //     this.$set(this.xiugaiFormData, 'siji', row.name) // 司机姓名
      //     this.$set(this.xiugaiFormData, 'phone', row.mobile) // 司机电话
      //     this.$set(this.xiugaiFormData, 'numberId', row.identityNo) // 身份证
      //   }
      // }
    },
    derverChange (val) {
      this.derverFrom.pageSize = val
      // this.getDerverList()
    },
    derverCurrentChange (val) {
      this.derverFrom.pageNo = val
      // this.getDerverList()
    },
    close () {
      this.tableVisible = false
      this.$emit('update:table', false)
    }
  }
}
</script>

<style>

</style>
